import React, {useEffect} from 'react';
import { NavLink } from 'react-router-dom';
import "../../../css/vendors.css";


const Sellers = () => {
    useEffect(() => {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      return () => {};
    }, []);

  return (
    <div className="">
      <div className="page-container" id="sellers">
        <section className="wrapper">
          <div className="container">
            <div className="row">
              <section className="sellers-item1 anim1">
                <div className="box highlight">
                  <i className="fa fa-fast-forward"></i>
                  <div className="inner">
                    <h3>Sell Faster</h3>
                    <p>
                      Your sales can never stop, when you join us. Weather you
                      are a company or an individual retailer.{" "}
                    </p>
                  </div>
                </div>
              </section>
              <section className="sellers-item2 anim2">
                <div className="box highlight">
                  <i className="fa fa-users"></i>
                  <div className="inner">
                    <h3>Sell To Employees</h3>
                    <p>
                      Employees buy as many as they wish, when it is on credit.
                      We then pay you immediately when they get salary.{" "}
                    </p>
                  </div>
                </div>
              </section>
              <section className="sellers-item3 anim3">
                <div className="box highlight">
                  <i className="fa fa-globe"></i>
                  <div className="inner">
                    <h3>Sell Globally</h3>
                    <p>
                      You can sell easily and faster accross Nigerian States,
                      also at affordable commissions{" "}
                    </p>
                  </div>
                </div>
              </section>
            </div>
            <div className="signup-btn anim4">
              <NavLink to="/vendor-signup">
                <button className="primary-btn">Get Started</button>
              </NavLink>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Sellers